import { render, staticRenderFns } from "./betSlip.vue?vue&type=template&id=b001f3b2&scoped=true&lang=pug&"
import script from "./betSlip.vue?vue&type=script&lang=js&"
export * from "./betSlip.vue?vue&type=script&lang=js&"
import style0 from "./betSlip.vue?vue&type=style&index=0&id=b001f3b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b001f3b2",
  null
  
)

export default component.exports